"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _metadata;
Object.defineProperty(exports, "__esModule", { value: true });
const CoreEntity_1 = __importDefault(require("./CoreEntity"));
const metadata_1 = require("../utils/metadata");
class App extends CoreEntity_1.default {
    constructor(data, metadata, connector) {
        var _a, _b;
        super(connector);
        _metadata.set(this, void 0);
        this.address = data.address;
        this.appId = data.appId;
        this.codeAddress = data.codeAddress;
        this.contentUri = data.contentUri || undefined;
        this.isForwarder = (_a = data.isForwarder) !== null && _a !== void 0 ? _a : undefined;
        this.isUpgradeable = (_b = data.isUpgradeable) !== null && _b !== void 0 ? _b : undefined;
        this.kernelAddress = data.kernelAddress;
        this.name = data.name;
        this.registry = data.registry || undefined;
        this.registryAddress = data.registryAddress;
        this.repoAddress = data.repoAddress;
        this.version = data.version;
        __classPrivateFieldSet(this, _metadata, metadata);
    }
    static async create(data, connector) {
        const artifact = await metadata_1.resolveArtifact(data);
        const manifest = await metadata_1.resolveManifest(data);
        const metadata = [artifact, manifest];
        return new App(data, metadata, connector);
    }
    async repo() {
        return this._connector.repoForApp(this.address);
    }
    async roles() {
        return this._connector.rolesForAddress(this.address);
    }
    get artifact() {
        return __classPrivateFieldGet(this, _metadata)[0];
    }
    get manifest() {
        return __classPrivateFieldGet(this, _metadata)[1];
    }
    get abi() {
        return this.artifact.abi;
    }
    get intents() {
        return this.artifact.functions;
    }
    get deprecatedIntents() {
        return this.artifact.deprecatedFunctions;
    }
    get appName() {
        return this.artifact.appName;
    }
}
exports.default = App;
_metadata = new WeakMap();
//# sourceMappingURL=App.js.map